import { Dropdown, Tooltip } from 'antd';
import type { DropdownProps, MenuProps, TooltipProps } from 'antd';
import type { ItemType } from 'antd/es/menu/interface';
import React from 'react';

export type FBItemType = NonNullable<ItemType> & {
  hide?: boolean;
  tooltip?: TooltipProps;
  'data-cy'?: string;
};

export type FBDropdownProps = Omit<DropdownProps, 'menu'> & {
  menu: Omit<MenuProps, 'items'> & { items?: FBItemType[] };
};

type FormattedItem = NonNullable<ItemType> & { 'data-cy'?: string };

export const formatMenuItems = (items: FBItemType[]): FormattedItem[] =>
  items.reduce<FormattedItem[]>((acc, { hide, tooltip, ...item }) => {
    if (hide) {
      return acc;
    }

    acc.push(item.type === 'divider' ? item : {
      'data-cy': `dropdown-item-${item.key}`,
      ...item,
      label: (
        <Tooltip placement="left" {...tooltip}>
          <div>{item.label}</div>
        </Tooltip>
      ),
    });
    return acc;
  }, []);

const FBDropdown: React.FC<FBDropdownProps> = ({ menu, children, ...props }) => {
  const { items = [], ...menuProps } = menu ?? {};

  const formattedItems = React.useMemo(() => formatMenuItems(items), [items]);

  return (
    <Dropdown {...props} menu={{ items: formattedItems, ...menuProps }}>
      {children}
    </Dropdown>
  );
};

export default FBDropdown;
